import React, { useLayoutEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { CaseProvider } from '../context/CaseContext';

// Wraps the /m/fir/* screen subtree so nested analysis screens share one
// fullFIR object instead of re-fetching or threading a setter through route params.
const CaseLayout = () => {
  const { pathname } = useLocation();

  // The scrollable content container (see MobileLayout) persists across route
  // changes, so without this a new screen opens at the previous screen's scroll offset.
  useLayoutEffect(() => {
    const container = document.getElementById('m-scroll-content');
    if (container) container.scrollTop = 0;
  }, [pathname]);

  return (
    <CaseProvider>
      <Outlet />
    </CaseProvider>
  );
};

export default CaseLayout;
